import { Dropdown, DropdownItem, InputField } from 'plume-ui';
import { AdjustableComponent } from 'plume-ui/dist/hooks/useClasses';
import { memo, useEffect, useState } from 'react';
import FormattedMessage from '../../../../../utils/components/FormattedMessage';
import {
  makePayload,
  mapMinutesToDaysHoursMinutes,
  verifyNumberInput,
} from '../helpers';
import {
  AffectedHrsType,
  FilterSubcriteriaDefaultProps,
  RangeMinutes,
} from '../types';
import { useTranslation } from 'react-i18next';

type AffectedHrsStyles = {
  root: string;
};

const AffectedHrs: AdjustableComponent<
  FilterSubcriteriaDefaultProps,
  AffectedHrsStyles
> = ({ allowedOperators, setValue, initialData }) => {
  const { t } = useTranslation();

  const [data, setData] = useState<AffectedHrsType>({
    value: {
      ...mapMinutesToDaysHoursMinutes(
        (initialData?.selectedValue as RangeMinutes)?.minutes || 0,
      ),
      range: '_duration_last_1d',
    },
    operator: initialData?.operator
      ? allowedOperators.find((op) => op.key === initialData.operator) ??
        allowedOperators[0]
      : allowedOperators[0],
    criteriaType: 'affectedHrs',
  });

  useEffect(() => {
    setValue(makePayload(data));
  }, [data]);

  return (
    <>
      <Dropdown closeOnItemClick label={data.operator.display} openInPortal>
        {allowedOperators.map((option) => (
          <DropdownItem
            key={option.key}
            onClick={() => setData({ ...data, operator: option })}
          >
            {option.display}
          </DropdownItem>
        ))}
      </Dropdown>
      <div className="AffectedHrs" data-testid="affected-hrs-component">
        <div className="AffectedHrs__input">
          <InputField
            type="number"
            id="affectedHours"
            value={data.value.hours}
            onInput={(event: any) => {
              const inputValue = verifyNumberInput(event.target.value, 23, 0);
              event.target.value = inputValue;
              setData({
                ...data,
                value: {
                  ...data.value,
                  hours: verifyNumberInput(inputValue, 23, 0),
                },
              });
            }}
            max={23}
            min={0}
            maxLength={2}
          />
          <label htmlFor="affectedHours">{t('genericLabels.hours')}</label>
        </div>
        <div className="AffectedHrs__input">
          <InputField
            type="number"
            id="affectedMinutes"
            value={data.value.minutes}
            onInput={(event: any) => {
              const inputValue = verifyNumberInput(event.target.value, 59, 0);
              event.target.value = inputValue;
              setData({
                ...data,
                value: {
                  ...data.value,
                  minutes: verifyNumberInput(inputValue, 59, 0),
                },
              });
            }}
            max={59}
            min={0}
            maxLength={2}
          />
          <label htmlFor="affectedMinutes">{t('genericLabels.minutes')}</label>
        </div>
        <div className="AffectedHrs__info">
          <FormattedMessage id="monitorAdd.inLast24hours" />
        </div>
      </div>
    </>
  );
};

export default memo(AffectedHrs);
